import useWindowDimensions from "helpers/screen";
import { useState } from "react";
import OpenOrdersBox from "../OpenOrdersBox";
import OrderBook from "../OrderBook";
import OrderBox from "../OrderBox";
import TradingChart from "../TradingChart";
import "./style.scss";

// layout: Trade body arrangement. [0 = Orderbook, 1 = Chart/Open Orders, 2 = Order Box]
const TradeBody = ({ marketData, layout, setLayout, updateMarket }) => {

  const {width} = useWindowDimensions();
  const [eventsQueue, setEventsQueue] = useState([]);
  const [limitPrice, setLimitPrice] = useState();
  const [tradeAmount, setTradeAmount] = useState();
  const [totalAmount, setTotalAmount] = useState();

  if(width > 768)
  return <div className="tradeBody">
    {
      layout.map((item, i) => {
        if(item === 0) return <OrderBook key={i} marketData={marketData} arrangement={i} setTradeAmount={setTradeAmount} setTotalAmount={setTotalAmount} setLimitPrice={setLimitPrice} setEventsQueue={setEventsQueue}/>;
        if(item === 1) return <div key={i} className="chartAndOrders">
          <TradingChart marketData={marketData} updateMarket={updateMarket}/>
          <OpenOrdersBox marketData={marketData} eventsQueue={eventsQueue}/>
        </div>
        if(item === 2) return <OrderBox key={i} marketData={marketData} arrangement={i} tradeAmount={tradeAmount} totalAmount={totalAmount} setTradeAmount={setTradeAmount} setTotalAmount={setTotalAmount} limitPrice={limitPrice} setLimitPrice={setLimitPrice}/>
      })
    }
  </div>

  if(width <= 768)
  return <div className="tradeBodyMobile">
    <div className="top">
      <OrderBook marketData={marketData} setTradeAmount={setTradeAmount} setTotalAmount={setTotalAmount} setLimitPrice={setLimitPrice} setEventsQueue={setEventsQueue}/>
      <OrderBox marketData={marketData} tradeAmount={tradeAmount} totalAmount={totalAmount} setTradeAmount={setTradeAmount} setTotalAmount={setTotalAmount} limitPrice={limitPrice} setLimitPrice={setLimitPrice}/>
    </div>
    <OpenOrdersBox marketData={marketData} updateMarket={updateMarket} eventsQueue={eventsQueue}/>
  </div>

}

export default TradeBody;